import { ChangeEvent, FC, useCallback, useMemo, useRef, useState } from "react";
import { Card, CardBody, CardFooter, CardHeader, Collapse } from "reactstrap";
import StarRate from "../../../components/StarRate";
import useClickOutside from "../../../hook/UseClickOutSide";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import { ReachClick } from "../../../utils/core";

const LOGO_MARK_WHITE = `${process.env.PUBLIC_URL}/images/logos/logo-mark-white.webp`;

const GUIDELINES_URL =
  "https://www.trustfinance.com/legal/for-reviewers/recommendations-for-reviewers?utm_source=widget&utm_medium=banner&utm_campaign=evaluate";

const WidgetTemplate3: FC<IWidgetTemplate> = ({ company }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [rate, setRate] = useState(0);
  const [des, setDes] = useState("");
  const widgetRef = useRef(null);

  const payload = useMemo(
    () => ({
      companyId: company?.data?.companyId,
      widgetId: 3 as const,
    }),
    [company?.data?.companyId],
  );

  const handleOpenDropdown = useCallback((value: number) => {
    setRate(value);
    setIsOpen(true);
  }, []);

  const handleDescriptionChange = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement>) => {
      setDes(e.target.value);
    },
    [],
  );

  const handleSubmitReview = useCallback(() => {
    ReachClick(payload);
    window.location.assign(
      `https://www.trustfinance.com/review/invite?from=widget&companyId=${company.companyId}&score=${rate}&des=${des}&utm_source=widget&utm_medium=banner&utm_campaign=evaluate`,
    );
  }, [payload, company.companyId, rate, des]);

  useClickOutside(widgetRef, () => {
    setIsOpen(false);
  });

  return (
    <div ref={widgetRef} className="container">
      <div>
        <div className="d-flex justify-content-center align-items-center cursor-pointer py-2">
          <div className="card">
            <div className="card-header bg-primary">
              <div className="d-flex align-items-center">
                <img
                  src={LOGO_MARK_WHITE}
                  alt="TrustFinance"
                  width={24}
                  height={24}
                  className="mr-2"
                />
                <span className="fs-18 text-white fw-bold pl-2">
                  TrustFinance
                </span>
              </div>
            </div>
            <div className="card-body">
              <h4>Rate your recent experience</h4>
              <div>
                <StarRate
                  value={rate}
                  selectable
                  onChange={handleOpenDropdown}
                />
              </div>
            </div>
          </div>
        </div>
        <Collapse isOpen={isOpen} horizontal={false}>
          <div className="d-flex justify-content-center align-items-center">
            <Card>
              <CardHeader className="d-flex align-items-center flex-column bg-white">
                <div className="d-flex">
                  <h4 className="me-2">Tell us about your experience</h4>
                </div>
                <a href={GUIDELINES_URL} target="_blank" rel="noreferrer noopener">
                  Read our Guidelines for Reviewers
                </a>
              </CardHeader>
              <CardBody>
                <textarea
                  rows={5}
                  onChange={handleDescriptionChange}
                  className="w-100"
                  placeholder="This is where you write your review. Explain what happened, and leave out offensive words. Keep your feedback honest, helpful, and constructive."
                />
                <a href={GUIDELINES_URL} target="_blank" rel="noreferrer noopener">
                  How to write a useful review
                </a>
              </CardBody>
              <CardFooter>
                <button className="btn btn-primary" onClick={handleSubmitReview}>
                  review
                </button>
              </CardFooter>
            </Card>
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default WidgetTemplate3;
